var modalOffsetBodyClassActive = false

function _addBodyClass () {
  if (!modalOffsetBodyClassActive) {
    const root = document.getElementsByTagName('html')[0]
    const body = document.getElementsByTagName('body')[0]
    body._ftFullModalActiveCount = body._ftFullModalActiveCount || 0
    if (!body._ftFullModalActiveCount) {
      var offset = document.scrollTop
      body.style.marginTop = 0 - offset + 'px'
      root.classList.add('ft-full-modal-active')
    }
    modalOffsetBodyClassActive = true
    body._ftFullModalActiveCount++
  }
}

function _removeBodyClass () {
  if (modalOffsetBodyClassActive) {
    const root = document.getElementsByTagName('html')[0]
    const body = document.getElementsByTagName('body')[0]
    body._ftFullModalActiveCount = body._ftFullModalActiveCount || 0
    if (body._ftFullModalActiveCount) {
      body._ftFullModalActiveCount--
    }
    if (!body._ftFullModalActiveCount) {
      body.style.marginTop = null
      root.classList.remove('ft-full-modal-active')
      modalOffsetBodyClassActive = false
    }
  }
}

export default {
  data () {
    return {
      modalOffsetBodyClassActive: false
    }
  },
  methods: {
    setPageScrollbarVisibility () {
      if (this.hidePageScrollbar) {
        _addBodyClass()
      } else {
        _removeBodyClass()
      }
    }
  },
  mounted () {
    this.setPageScrollbarVisibility()
  },
  watch: {
    hidePageScrollbar (val) {
      this.setPageScrollbarVisibility()
    }
  },
  beforeDestroy () {
    _removeBodyClass()
  }
}
